import script from "./ProjectItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectItem.vue?vue&type=script&setup=true&lang=js"

import "./ProjectItem.vue?vue&type=style&index=0&id=d5f05d44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d5f05d44"]])

export default __exports__